import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  installMessage: {
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 999,
    display: "flex",
    alignItems: "center",
    padding: "17px 16px",
    backgroundColor: "#5FC9F8",
    color: "#fff"
  },
  closeIcon: {
    position: "absolute",
    top: 6,
    right: 6,
    fontSize: 12,
    opacity: 0.7,
    color: "#fff"
  },
  plusIcon: {
    maxWidth: 30,
    marginRight: theme.spacing(2)
  },
  shareIcon: {
    maxWidth: "16px",
    position: "relative",
    bottom: "-5px",
    margin: "0 4px"
  },
  text: {
    position: "relative",
    top: "-3px"
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/InstallMessage/styles.js